import { HTTP } from './helpers/http.js'
import qs from 'qs'

export default {
  getTeams(organizationId, options = {}) {
    const params = {
      params: options,
      paramsSerializer(parameters) {
        return qs.stringify(parameters, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v1/organizations/${organizationId}/teams`
    return HTTP.get(url, params)
  },

  getTeamsStream(organizationId, options = {}) {
    const params = {
      params: options,
      paramsSerializer(parameters) {
        return qs.stringify(parameters, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v1/stream/${organizationId}/teams`
    return HTTP.get(url, params)
  },

  getTeamsCatalog(organizationId, options = {}) {
    const params = {
      params: options,
      paramsSerializer(parameters) {
        return qs.stringify(parameters, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v1/organizations/${organizationId}/teams/catalog`
    return HTTP.get(url, params)
  },

  getTeamById(organizationId, teamId) {
    const url = `/api/v1/organizations/${organizationId}/teams/${teamId}`
    return HTTP.get(url)
  },

  create(organizationId, teamData) {
    const url = `/api/v1/organizations/${organizationId}/teams`
    return HTTP.post(url, { ...teamData, organization: organizationId })
  },

  update(organizationId, teamId, teamData) {
    const { name, leaders, site } = teamData
    const url = `/api/v1/organizations/${organizationId}/teams/${teamId}`

    const payload = {
      name,
      leaders,
      organization: organizationId,
    }

    if (site) {
      payload.site = site
    }

    return HTTP.patch(url, teamData)
  },

  updateMembers(organizationId, teamId, members) {
    const url = `/api/v1/organizations/${organizationId}/teams/${teamId}/members`
    return HTTP.patch(url, { members })
  },

  delete(organizationId, teamId) {
    const url = `/api/v1/organizations/${organizationId}/teams/${teamId}`
    return HTTP.delete(url)
  },
}
